import JwtService from "@/utils/jwt.service";

export default {
  set_error(state, error) {
    state.errors = error;
    state.message = [];
    for (const field in error) {
      if ({}.propertyIsEnumerable.call(error, field)) {
        const msg = error[field];
        state.message.push(field + " " + msg[0]);
      }
    }
  },
  set_auth(state, token) {
    state.isAuthenticated = true;
//    state.isAdmin = state.user.admin === 1;
//    state.accessLevel = state.user.role;
    JwtService.saveToken(token);
  },
  set_user(state, user) {
    state.user = user;
  },
  purge_auth(state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = null;
    JwtService.destroyToken();
  },
  fetch_end(state, { billings, billingsCount }) {
    state.billings = billings;
    state.billingsCount = billingsCount;
    state.isLoading = false;
  },
  set_loading(state, loading) {
    state.loading = loading;
  },
  clearMessage(state) {
    state.message = [];
  }
};
